/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const updatePriceSizeSchema = z.object({
	price: z.number(),
	size: z.uuid(),
});
